
<div mat-dialog-title>
  <fa-icon icon="times" (click)="onClick(false)" id="fdm-dialog-close" class="fdm-icon float-right"></fa-icon>
  {{data.title | translate }}
</div>

<div mat-dialog-content>

  <p>{{data.text  | translate }}</p>
    
  <mat-checkbox *ngIf="data.checkboxText" color="primary" [(ngModel)]="checkboxValue">{{data.checkboxText | translate}}</mat-checkbox>

</div>
<div mat-dialog-actions class="align-content-right" style="margin-bottom:inherit!important">

    <!-- button for cancel / no / false  (first, so it left-aligns -->
    <button mat-stroked-button  *ngIf="data.negBtn" color="danger" (click)="onClick(false)" translate>{{data.negBtn | translate }}</button>

    <button mat-stroked-button  *ngIf="data.posBtn" color="primary" (click)="onClick(true)" translate>{{data.posBtn | translate }}</button>

</div>
